module.exports = __webpack_public_path__ + "confirmation-icon.png?f87b6e212bc4204fde89724bcab4a162";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confirmation-icon.png
// module id = 215
// module chunks = 0